/*
 * @Date: 2023-11-28 18:30:44
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-07 18:12:36
 * @FilePath: \hisea-ssr\src\common\hooks\hook-wrappers\useInformedFieldStateWrapper.js
 */
"use client"
import {
  useFieldState 
} from "informed"
import {
  useEffect, useState 
} from "react"

const useInformedFieldStateWrapper = (field) => {
  const [isInitialRender, setIsInitialRender] = useState(true)
  // const warn = console.warn
  // Temporarily override console warn to remove false positive warning from useFieldState
  const regex = /^Attempting to get field (.*) but it does not exist$/g

  if (isInitialRender) {
    // console.warn = (err) => {
    //     if (!err.match(regex)) {
    //         warn(err)
    //     }
    // }
  }

  useEffect(() => {
    setIsInitialRender(false)
  }, [])

  const fieldState = useFieldState(field)

  if (isInitialRender) {
    // console.warn = warn
  }

  return fieldState
}

export default useInformedFieldStateWrapper
